module.exports = __webpack_public_path__ + "img/new-origem.c90eba42.svg";